/* Spanish catalog mirroring locale-bank-misc-fr-part2.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'km.privateDrivingHelp': 'El uso privado se documenta en el registro de kilometraje, pero no da derecho a deducción.',
  'km.filterType': 'Tipo',
  'km.tryOtherSearch': 'Prueba con otra búsqueda o restablece el filtro.',
  'km.distance': 'Distancia',
  'km.stops': 'Paradas',
  'km.returnYes': 'Sí ({km} km por trayecto)',
  'km.returnNo': 'No',
  'km.status': 'Estado',
  'km.statusLogged': 'Registrado',
  'km.statusPosted': 'Contabilizado',
  'km.route': 'Ruta',
  'km.amount': 'Importe',
  'km.deleteTripBody': '¿Seguro que quieres eliminar este viaje{route}? Esta acción no se puede deshacer.',
  'km.speedUnit': 'km/h',
  'km.gps.unavailable': 'El GPS no está disponible en este navegador.',
  'km.gps.denied': 'Se denegó el acceso al GPS o no se pudo iniciar.',
  'km.gps.active': 'GPS activo',
  'km.gps.inactive': 'El GPS no está activo',
  'km.gps.stop': 'Detener viaje',
  'km.gps.start': 'Iniciar viaje',
  'km.gps.done': 'Viaje completado',
  'km.gps.tracking': 'Siguiendo tu posición.',
  'km.gps.doneHint': '{km} km registrados. Usa la distancia en el formulario de abajo.',
  'km.gps.startHint': 'Inicia el viaje para activar el seguimiento por GPS.',
  'km.toast.editTrip': 'Editar viaje: modifícalo y guárdalo de nuevo',
  'km.toast.openedNotFound': 'Se abrió el registro de kilometraje. No se pudo encontrar automáticamente el viaje exacto que editar.',
  'km.toast.fillFromTo': 'Rellena primero al menos las direcciones de origen y destino.',
  'km.toast.calcUnavailable': 'El cálculo automático de km aún no está disponible.',
  'km.toast.distanceFailed': 'No se pudo calcular la distancia.',
  'km.toast.kmCalculated': 'Kilómetros calculados automáticamente',
  'km.toast.calcFailed': 'No se pudieron calcular los kilómetros automáticamente.',
  'km.toast.fillPrivate': 'Rellena la fecha, el origen, el destino y los kilómetros antes de guardar la conducción privada.',
  'km.toast.fillBusiness': 'Rellena la fecha, el origen, el destino, el motivo y los kilómetros antes de guardar.',
  'km.toast.updated': 'El viaje se ha actualizado',
  'km.toast.saved': 'El viaje se ha guardado',
  'km.toast.deleted': 'Viaje eliminado',
  'bank.filter.all': 'Todas',
  'bank.filter.processing': 'Por procesar',
  'bank.filter.suggestion': 'Sugerencia lista',
  'bank.filter.control': 'Requiere revisión',
  'bank.filter.missing': 'Falta el justificante',
  'bank.filter.deviation': 'Posible desviación',
  'bank.filter.done': 'Hecho',
  'bank.typeGroup.sales': 'Ventas',
  'bank.typeGroup.purchase': 'Compras',
  'bank.typeGroup.other': 'Otros',
  'bank.typeGroup.tax': 'Impuestos y tasas',
  'bank.typeGroup.loan': 'Préstamos y deuda',
  'bank.type.invoicePayment': 'Pago de factura',
  'bank.type.otherSales': 'Otras ventas',
  'bank.type.payOpenSupplier': 'Factura de proveedor: pagar pendiente',
  'bank.type.newSupplier': 'Factura de proveedor: registrar nueva',
  'bank.type.purchase': 'Compra normal',
  'bank.type.free': 'Asiento libre',
  'bank.type.fee': 'Comisión',
  'bank.type.rounding': 'Diferencia de redondeo',
  'bank.type.owner': 'Retirada / aportación privada',
  'bank.type.vat': 'Pago de IVA',
  'bank.type.payroll': 'Retención de impuestos / cotizaciones del empleador',
  'bank.type.tax': 'Pago de impuestos',
  'bank.type.loan': 'Préstamo / deuda',
  'bank.agaPart.withholding': 'Retención de impuestos en la 2600',
  'bank.agaPart.employer': 'Cotizaciones del empleador en la 2770',
  'bank.agaPart.both': 'Ambas combinadas, divididas entre la 2600 y la 2770',
  'bank.vat.none': 'Sin IVA',
  'bank.vat.input': '{{code}} - IVA soportado {{rate}} %',
  'bank.accountFallback': 'Cuenta {{code}}',
  'bank.countsAsZero': '{{note}} · cuenta como 0,00 kr en la conciliación',
  'bank.csv.date': 'Fecha',
  'bank.csv.description': 'Descripción',
  'bank.csv.note': 'Nota',
  'bank.csv.amount': 'Importe',
  'bank.csv.balance': 'Saldo',
  'bank.posted.amount': 'Contabilizado {{amount}}',
  'bank.posted': 'Contabilizado',
  'bank.posted.vatAmount': 'IVA {{amount}} ({{rate}} %)',
  'bank.posted.vatRate': 'IVA {{rate}} %',
  'bank.err.pickSupplierInvoice': 'Selecciona la factura de proveedor a la que corresponde el pago.',
  'bank.err.supplierPaymentMustBeOutgoing': 'El pago de una factura de proveedor debe ser un pago bancario saliente.',
  'bank.err.supplierPaymentUnavailable': 'El pago de una factura de proveedor desde el banco aún no está disponible.',
  'bank.deviation.intro': 'Estos asientos están contabilizados en la cuenta bancaria, pero Plumme no encuentra ninguna línea bancaria segura que los explique.',
  'bank.deviation.none': 'No hay posibles desviaciones en este periodo.',
  'bank.detail.date': 'Fecha',
  'bank.detail.amount': 'Importe',
  'bank.detail.status': 'Estado',
  'bank.detail.postId': 'ID del asiento',
  'bank.detail.type': 'Tipo',
  'bank.detail.period': 'Periodo',
  'bank.detail.noReceipt': 'No hay ningún justificante vinculado al asiento',
  'bank.detail.receiptPreviewable': 'El justificante se puede previsualizar directamente aquí.',
  'bank.detail.noPreview': 'No hay ningún justificante que previsualizar.',
  'bank.toast.postingCorrected': 'El asiento contabilizado se ha corregido',
  'bank.toast.postingVoided': 'El asiento se ha anulado. Si había un justificante, vuelve a la bandeja de entrada.',
  'bank.transition.review': 'Revisa la transición desde las cuentas importadas antes de contabilizar este extracto.',
  'bank.transition.fixOpening': '{{message}} Corrige el saldo inicial antes de contabilizar.',
  'bank.toast.voucherLinkedName': 'Justificante vinculado: {{name}}',
  'bank.toast.noVoucherSuggestions': 'SuperPlumma no tiene sugerencias de justificantes que vincular.',
  'bank.toast.oneVoucherLinked': 'Un justificante vinculado',
  'bank.toast.nVouchersLinked': '{{count}} justificantes vinculados',
  'bank.toast.linkSuggestedFailed': 'No se pudieron vincular los justificantes sugeridos.',
  'bank.toast.linkedToPosted': 'La línea bancaria está vinculada al asiento ya contabilizado',
  'bank.toast.linkToPostedFailed': 'No se pudo vincular la línea bancaria al asiento contabilizado.',
  'bank.toast.saveCustomerFirst': 'Guarda el cliente antes de aprobar la línea.',
  'bank.toast.saveSupplierFirst': 'Guarda o selecciona el proveedor antes de aprobar la línea.',
  'bank.toast.reviewSuggestionFirst': 'Revisa la sugerencia en la línea bancaria antes de aprobar.',
  'bank.toast.invoicePaymentDone': 'El pago de la factura está contabilizado y la línea bancaria está hecha',
  'bank.toast.supplierPaymentDone': 'La factura del proveedor está pagada y la línea bancaria está hecha',
  'bank.toast.enterSupplierName': 'Introduce el nombre del proveedor antes de aprobar la factura.',
  'bank.toast.enterInvoiceNumber': 'Introduce el número de factura antes de aprobar la factura.',
  'bank.toast.checkCostAccount': 'Comprueba la cuenta de gasto antes de aprobar la factura.',
  'bank.toast.supplierInvoiceDone': 'La factura del proveedor está contabilizada y la línea bancaria está hecha',
  'bank.toast.suggestionDone': 'La sugerencia está contabilizada y la línea bancaria está hecha',
  'bank.toast.alreadyDone': 'La línea bancaria ya está contabilizada y hecha',
  'bank.toast.suggestionNotApproved': 'No se pudo aprobar la sugerencia.',
  'bank.toast.suggestionNeedsReview': 'La sugerencia debe revisarse antes de aprobarla.',
  'bank.approve': 'Aprobar',
  'bank.toast.pickUnprocessed': 'Selecciona al menos una línea bancaria sin procesar.',
  'bank.toast.approveLineFailed': 'No se pudo aprobar la línea bancaria.',
  'bank.toast.nLinesApproved': '{{count}} líneas aprobadas',
  'bank.toast.lineAdded': 'Línea bancaria añadida',
  'bank.toast.lineLinkUnavailable': 'La vinculación de una línea bancaria aún no está disponible.',
  'bank.toast.linkedToExistingPosted': 'La línea bancaria está vinculada al asiento contabilizado existente',
  'bank.controlPosting.title': 'Asiento bancario contabilizado',
  'bank.controlPosting.sub': 'Posible desviación: contabilizado en la cuenta bancaria, pero no encontrado en el extracto bancario.',
  'bank.toast.openedAsDeviation': 'La línea bancaria se ha abierto como desviación',
  'bank.toast.investmentMatchReopened': 'Se ha liberado la conciliación bancaria con la inversión',
  'bank.toast.balanceCorrectionUnavailable': 'La corrección de saldo aún no está disponible.',
  'bank.toast.openingMustBeNumber': 'El saldo inicial debe ser un número.',
  'bank.toast.openingUpdated': 'Saldo inicial actualizado',
  'bank.toast.openingFromImport': 'Saldo inicial establecido a partir de la transición de la importación',
  'bank.toast.closingMustBeNumber': 'El saldo final debe ser un número.',
  'bank.toast.closingUpdated': 'Saldo final actualizado',
  'bank.toast.roundingMustBeNumber': 'La diferencia de redondeo debe ser un número.',
  'bank.toast.roundingCorrected': 'Diferencia de redondeo corregida',
  'bank.mark.posted': 'Contabilizado',
  'bank.mark.alreadyPosted': 'Ya contabilizado',
  'bank.mark.approved': 'Aprobado',
  'bank.mark.needsReview': 'Requiere revisión',
  'bank.mark.deviation': 'Posible desviación',
  'bank.mark.suggestion': 'Sugerencia lista',
  'bank.mark.private': 'Privado',
  'bank.mark.removed': 'Eliminado',
  'bank.mark.new': 'Sin procesar',
  'bank.toast.analysisUnavailable': 'El análisis de SuperPlumma aún no está disponible.',
  'bank.toast.foundSuggestions': 'SuperPlumma encontró {{count}} sugerencias para revisar',
  'bank.toast.noSafeSuggestions': 'SuperPlumma no encontró sugerencias seguras',
  'bank.toast.analysisFailed': 'SuperPlumma no pudo analizar las líneas bancarias.',
  'bank.toast.alreadyArchived': 'El extracto bancario ya está conciliado y archivado.',
  'bank.toast.reconciledArchived': 'El extracto bancario está conciliado y archivado.',
  'bank.toast.reopenFailed': 'No se pudo reabrir la conciliación.',
  'bank.matchMultiple': 'Conciliar varias',
  'bank.transition.title': 'Revisa la transición desde las cuentas importadas',
  'bank.transition.changeAnchor': 'Cambia «Conciliado hasta» y el saldo inicial en Ajustes si el punto de partida de la importación se estableció de forma incorrecta.',
  'bank.previousNotReconciled': 'Un periodo anterior no está conciliado',
  'bank.correctViaPencil': 'Corregir con el icono del lápiz',
  'bank.correctReadBalance': 'Corregir el saldo leído',
  'bank.analysis.alreadyDone': 'El extracto bancario ya se ha analizado. Se bloquea un nuevo análisis para evitar un uso innecesario de tokens.',
  'bank.analysis.autoRunning': 'SuperPlumma está analizando el extracto bancario automáticamente.',
  'bank.analysis.analyzedShort': 'Analizado por SuperPlumma',
  'bank.analysis.analyzingShort': 'SuperPlumma está analizando',
  'bank.archiveBlocked.chronological': 'Concilia primero {{name}}. La conciliación debe hacerse en orden cronológico, porque el saldo inicial se toma del extracto anterior.',
  'bank.archiveBlocked.deviation': 'La diferencia de saldo debe ser 0,00 kr antes de poder archivar el extracto bancario.',
  'bank.archiveBlocked.lines': 'Todas las líneas bancarias deben procesarse antes de poder archivar el extracto bancario.',
  'bank.reviewAndApprove': 'Revisar y aprobar',
  'bank.voucherN': 'Justificante {{n}}',
  'bank.voucherLinked': 'Justificante vinculado',
  'bank.showVoucher': 'Mostrar justificante',
  'bank.voucherSuggested': 'Justificante sugerido',
  'bank.voucherMissingBadge': 'Falta el justificante',
  'bank.toast.linkRemoved': 'El vínculo se ha eliminado. El justificante vuelve a la bandeja de entrada.',
  'bank.sendVouchersBack': 'Devolver los justificantes a la bandeja de entrada',
  'bank.toast.vouchersSentBack': 'Los justificantes se han devuelto a la bandeja de entrada',
  'bank.analysisHint.tap': 'Deja que SuperPlumma analice las líneas y sugiera asientos, o toca un justificante y después la línea bancaria para vincularlo.',
  'bank.analysisHint.drag': 'Deja que SuperPlumma analice las líneas y sugiera asientos, o arrastra un justificante directamente a la línea bancaria para vincularlo.',
  'bank.showInbox': 'Mostrar bandeja de entrada',
  'bank.toast.lineDone': 'La línea bancaria está contabilizada y hecha',
  'bank.toast.noInboxVouchers': 'No hay justificantes en la bandeja de entrada que vincular.',
  'bank.toast.balanceCorrected': 'El saldo se ha corregido',
  'bank.toast.misreadRemoved': 'La línea mal leída se ha eliminado de la conciliación',
  'bank.toast.readingCorrected': 'La lectura se ha corregido',
  'bank.toast.postedFixed': 'El asiento contabilizado se ha corregido',
  'bank.toast.lineRemoved': 'La línea bancaria se ha eliminado de la conciliación',
  'bank.vatTerm.jun': 'IVA {{year}} - 10 de junio',
  'bank.vatTerm.apr': 'IVA {{year}} - 10 de abril',
  'bank.vatTerm.feb': 'IVA {{year}} - 10 de febrero',
  'bank.vatTerm.aug': 'IVA {{year}} - 31 de agosto',
  'bank.vatTerm.oct': 'IVA {{year}} - 10 de octubre',
  'bank.vatTerm.dec': 'IVA {{year}} - 10 de diciembre',
  'bank.agaTerm': 'Impuesto sobre nóminas/cotizaciones del empleador, periodo {{n}} {{year}}',
  'bank.ownerAccountFallback': 'Cuenta privada/del propietario',
  'bank.periodHint': 'El extracto bancario abarca {{from}} - {{to}}.',
  'bank.voucher': 'Justificante',
  'bank.ownerType.withdrawal': 'Retirada privada',
  'bank.ownerType.deposit': 'Aportación privada',
  'bank.ownerType.both': 'Retirada / aportación privada',
  'bank.ownerType.owner': 'Cuenta del propietario / intercompañía',
  'bank.vat86.prefix': 'El importe del proveedor',
  'bank.vat86.suffix': 'es la base. El código 86 calcula tanto el IVA repercutido como el soportado al 25 % sin reducir el importe bancario.',
  'bank.postedWithoutVat': 'se contabiliza sin IVA.',
  'bank.withVatRate': 'con un {{rate}} % de IVA.',
  'bank.amountHelp.locked': 'El importe se toma del extracto bancario y no se puede modificar.',
  'bank.amountHelp.unlocked': 'El asiento no está vinculado a una línea bancaria, por lo que el importe se puede corregir aquí. El cambio se guarda en el registro de auditoría.',
  'bank.amountHelp.mustMatch': 'El importe debe coincidir con la transacción bancaria real.',
  'bank.err.enterAmount': 'Introduce el importe bancario antes de guardar la línea.',
  'bank.err.dateWithinStatement': 'La fecha debe estar dentro del extracto bancario: {{from}} - {{to}}.',
  'bank.err.pickTwoAccountsFree': 'Selecciona dos cuentas distintas antes de guardar el asiento libre.',
  'bank.err.enterSupplierName': 'Introduce el nombre del proveedor antes de guardar la factura del proveedor.',
  'bank.err.enterInvoiceNumber': 'Introduce el número de factura antes de contabilizar la factura del proveedor.',
  'bank.err.invoicePaymentIncoming': 'El pago de una factura debe ser un pago bancario entrante.',
  'bank.err.pickInvoice': 'Selecciona una factura antes de guardar el pago de la factura.',
  'bank.err.pickOwnerAccount': 'Selecciona la cuenta privada/del propietario antes de aprobar el asiento.',
  'bank.err.pickLoanAccount': 'Selecciona una cuenta de préstamo/deuda o usa un asiento libre.',
  'bank.err.loanSplitSum': 'El principal, los intereses y las comisiones deben sumar el importe bancario.',
  'bank.err.supplierPaymentOutgoing': 'El pago de una factura de proveedor debe ser un pago bancario saliente.',
  'bank.err.pickSupplierInvoiceBeforeSave': 'Selecciona una factura de proveedor antes de guardar el pago.',
  'bank.err.correctionReason': 'Indica brevemente por qué se corrige el asiento.',
  'bank.err.noReceiptReason': 'Introduce un breve motivo por el que no se necesita un justificante independiente.',
  'bank.err.linkVoucherOrWaive': 'Vincula un justificante o marca la casilla para indicar que no existe o no se necesita documentación independiente.',
  'bank.err.uploadUnavailable': 'La subida de justificantes aún no está disponible.',
  'bank.err.analysisFailedAfterUpload': 'El justificante se subió, pero el análisis falló.',
  'bank.toast.uploadedAndLinked': 'Justificante subido y vinculado a la línea bancaria.',
  'bank.toast.linkOnSaveCorrection': 'El justificante se vinculará cuando guardes la corrección.',
  'bank.toast.linkOnSaveLine': 'El justificante se vinculará cuando guardes la línea bancaria.',
  'bank.err.uploadFailed': 'No se pudo subir el justificante.',
  'bank.modal.correctPosting': 'Corregir asiento',
  'bank.modal.editLine': 'Editar línea bancaria',
  'bank.modal.saveCorrection': 'Guardar corrección',
  'bank.modal.approveAndClose': 'Aprobar y cerrar',
  'bank.modal.fieldsLocked': 'El importe bancario, la fecha, el tipo y el vínculo bancario están bloqueados. La cuenta, el IVA y la descripción interna se pueden corregir con registro de auditoría.',
  'bank.modal.correctionUnlocked': 'El asiento no está vinculado a una línea bancaria del extracto bancario. La fecha, el importe, la cuenta, el IVA, el justificante y la descripción interna se pueden corregir con registro de auditoría. Si el tipo de asiento es incorrecto, el asiento debe anularse y contabilizarse de nuevo.',
  'bank.modal.manualLineHelp': 'Úsalo solo cuando falte una transacción bancaria real en el extracto, por ejemplo por un error de importación o una línea bancaria que debe contabilizarse manualmente antes de la conciliación.',
  'bank.help.sales': 'Las ventas usan la cuenta de ventas y la configuración de IVA predeterminadas. Más adelante se vincularán con la factura/KID cuando estén disponibles.',
  'bank.help.ownerSole': '{{label}} se contabiliza entre el banco y la cuenta privada seleccionada, sin ingresos, costes ni IVA.',
  'bank.help.ownerUnknownEntity': 'El tipo de entidad no está definido en los ajustes, por lo que Plumme no sugiere una cuenta aquí. Elige tú la contrapartida o define el tipo de entidad para obtener una sugerencia.',
  'bank.help.ownerIntercompany': 'Este es un asiento de cuenta del propietario/intercompañía, no un asiento de empresa individual privada. Elige una contrapartida documentada; los préstamos, dividendos y aportaciones de capital deben tratarse en el flujo correspondiente.',
  'bank.label.privateAccount': 'Cuenta privada',
  'bank.label.ownerAccount': 'Cuenta del propietario/intercompañía',
  'bank.help.shareholderTitle': 'Retirada de la empresa.',
  'bank.help.shareholderBody': 'Se sugiere la cuenta intercompañía porque agrupa la relación con el propietario en un solo saldo. Si no se trata de la devolución de lo que la empresa te debe, se convierte en un préstamo a un accionista: el artículo 8-7 de la ley noruega de sociedades de responsabilidad limitada establece requisitos de cobertura y garantía, y el artículo 10-11, cuarto párrafo, de la ley tributaria lo grava como dividendo para ti. Los dividendos y los salarios deben contabilizarse en sus propios flujos.',
  'bank.help.invoicePayment': 'Úsalo cuando el ingreso bancario corresponda a una factura de venta existente. El asiento va contra clientes y la cuenta bancaria seleccionada.',
  'bank.settlement.linked': 'Informe de liquidación vinculado:',
  'bank.settlement.detail': 'la factura se paga con {{gross}}, comisión {{fee}} e ingreso bancario neto {{payout}}.',
  'bank.help.noInvoiceMatch': 'Cambia el importe o usa Otras ventas si el ingreso no corresponde a una factura.',
  'bank.help.supplierPayment': 'Úsalo cuando el pago bancario corresponda a una factura de proveedor ya registrada. El pago se contabiliza contra proveedores y la cuenta bancaria seleccionada.',
  'bank.pickOpenSupplierInvoice': 'Selecciona una factura de proveedor abierta',
  'bank.supplierInvoiceRemaining': '{{number}} · {{supplier}} · {{amount}} pendiente',
  'bank.overpayment': 'Pago en exceso de {{amount}}.',
  'bank.overpaymentHelp': 'Todo el importe bancario se registra en la factura del proveedor y el exceso queda como crédito con el proveedor.',
  'bank.noSupplierInvoiceFits': 'Ninguna factura de proveedor abierta coincide con el importe.',
  'bank.noSupplierInvoiceFitsHelp': 'En caso de pago en exceso, el importe restante debe conciliarse con la factura y el exceso contabilizarse por separado.',
  'bank.help.taxPayment': 'Úsalo solo para pagos a la Administración Tributaria noruega que no sean un periodo de IVA concreto ni retención de impuestos/cotizaciones del empleador.',
  'bank.selectedFeeAccount': 'la cuenta de comisiones seleccionada',
  'bank.selectedRoundingAccount': 'la cuenta de redondeo seleccionada',
  'bank.help.roundingWarning': 'Una diferencia de redondeo normalmente debería ser inferior a 1 kr. Las desviaciones mayores deben explicarse revisando el saldo y las líneas bancarias.',
  'bank.help.free': 'El asiento libre se usa para transferencias, deuda, cuentas intercompañía, correcciones u otros eventos bancarios que no son una compra, una venta o un pago de factura normales.',
  'bank.help.newSupplierInvoice': 'Úsalo cuando la factura del proveedor aún no esté registrada. La línea bancaria se guarda con los datos de la factura del proveedor para poder vincularla más adelante.',
  'bank.correction.requiredHint': 'Obligatorio. Se guarda en el registro de auditoría.',
  'bank.correction.reasonPh': 'Describe brevemente por qué se corrige el asiento',
  'bank.noSeparateDoc.bank': 'El extracto bancario es la documentación: no se necesita un justificante independiente',
  'bank.noSeparateDoc.other': 'No existe ni se necesita documentación independiente',
  'bank.shortReasonPh': 'Motivo breve',
  'bank.toast.pickFromInbox': 'Selecciona un justificante de la Bandeja de entrada, no de Documentación.',
  'bank.toast.linkedOnCorrection': 'El justificante se vincula cuando guardas la corrección.',
  'bank.toast.linkedToLine': 'El justificante está vinculado a la línea bancaria.',
  'bank.priv.filterAll': 'Todas',
  'bank.priv.filterOperating': 'Operativas',
  'bank.priv.filterNew': 'Sin procesar',
  'bank.priv.filterIgnore': 'Ignorar',
  'bank.priv.statusIgnored': 'Ignorada',
  'bank.priv.noSafeMatches': 'Aún no hay coincidencias seguras de justificantes que vincular',
  'bank.priv.linkedN': 'Se vincularon {{count}} justificantes a líneas bancarias privadas',
  'bank.priv.pickOneLine': 'Selecciona al menos una línea bancaria.',
  'bank.priv.ignoredN': '{{count}} líneas ignoradas',
  'bank.priv.movedN': '{{count}} líneas movidas a operativa',
  'bank.priv.intro': 'El banco privado se usa como herramienta de depuración: marca como Operativas las líneas relacionadas con la empresa e ignora las líneas privadas o irrelevantes. Las líneas marcadas como operativas se contabilizan en la cuenta operativa.',
  'bank.priv.movedToOperating': 'Movida a operativa',
  'bank.priv.noteTap': 'Deja que SuperPlumma las vincule automáticamente, o toca un justificante y después la línea bancaria.',
  'bank.priv.noteDrag': 'Deja que SuperPlumma las vincule automáticamente, o arrastra un justificante directamente a la línea bancaria.',
  'bank.toast.lineUpdated': 'Línea bancaria actualizada',
  'bank.err.excelParserMissing': 'No se ha cargado el analizador de Excel.',
  'bank.err.pdfParserMissing': 'No se ha cargado el analizador de PDF.',
  'bank.toast.addBankAccountFirst': 'Añade primero una cuenta bancaria en los ajustes',
  'bank.err.archiveUnavailable': 'El archivado de un extracto bancario aún no está disponible.',
  'bank.toast.privateReviewArchived': 'La revisión privada se ha completado y archivado',
  'bank.err.archiveFailed': 'No se pudo archivar el extracto bancario',
  'bank.err.reopenUnavailable': 'La reapertura de un extracto bancario aún no está disponible.',
  'bank.toast.statementReopened': 'El extracto bancario se ha reabierto',
  'bank.err.reopenStatementFailed': 'No se pudo reabrir el extracto bancario',
  'bank.account.private': 'Cuenta privada',
  'bank.account.operating': 'Cuenta operativa',
  'bank.group.operating': 'Cuentas operativas',
  'bank.group.private': 'Cuentas privadas',
  'bank.group.doneReviews': 'Revisiones de extractos privados completadas',
  'bank.group.doneReconciled': 'Extractos bancarios conciliados completados',
  'bank.unknownPeriod': 'Periodo desconocido',
  'bank.handledOf': '{{handled}} de {{lines}} gestionadas',
  'bank.page.privateTitle': 'Banco privado',
  'bank.page.title': 'Conciliación bancaria',
  'bank.page.privateSubtitle': 'Depura la cuenta privada: marca como operativas las líneas relacionadas con la empresa e ignora el resto.',
  'bank.page.subtitle': 'Sube un XLSX, CSV, PDF o una captura de pantalla del banco, marca las líneas de la empresa como operativas y archiva los extractos completados.',
  'bank.tab.operating': 'Operativa',
  'bank.tab.private': 'Privada',
  'bank.tab.archive': 'Archivo',
  'bank.page.privateUploadHelp': 'Sube aquí el extracto privado solo cuando quieras encontrar gastos relacionados con la empresa. Se guarda en la empresa seleccionada, pero sin una cuenta bancaria de Ajustes.',
  'bank.noAccountRegistered': 'No hay ninguna cuenta bancaria registrada',
  'bank.stmt.reviewed': 'Revisado',
  'bank.stmt.toReview': 'Por revisar',
  'bank.stmt.toReconcile': 'Por conciliar',
  'bank.dropzone.uploadMore': 'Subir más extractos bancarios',
  'bank.dropzone.none': 'Aún no hay extractos bancarios',
  'bank.dropzone.help': 'Arrastra un archivo CSV, PDF, XLSX o de imagen del banco, haz clic para seleccionarlo o pega una captura de pantalla con Ctrl+V. Conciliamos automáticamente las líneas con tus justificantes.',
  'bank.connectHelp2': 'Obtén las transacciones automáticamente y deja que SuperPlumma contabilice y concilie las cuentas de forma continua, sin subidas ni contabilizaciones manuales.',
  'bank.toast.openBankingInfo': 'Conexión segura con el banco mediante Open Banking',
  'bank.guided.step1.title': 'Revisar el extracto',
  'bank.guided.step1.sub': 'Comprueba el periodo y el saldo',
  'bank.guided.step2.title': 'Aprobar sugerencias',
  'bank.guided.step2.sub': 'Revisa lo que ha encontrado Plumme',
  'bank.guided.step3.title': 'Procesar el resto',
  'bank.guided.step3.sub': 'Elige para qué son los pagos',
  'bank.guided.step4.title': 'Vincular justificantes',
  'bank.guided.step4.sub': 'Documenta las compras',
  'bank.guided.step5.title': 'Finalizar',
  'bank.guided.step5.sub': 'Comprobar y archivar',
  'bank.guided.stepOf': 'Paso {{step}} de {{total}}',
  'bank.guided.action.matched': 'Conciliado con asiento ya contabilizado',
  'bank.guided.action.fee': 'Comisión bancaria',
  'bank.guided.action.invoice': 'Pago de factura',
  'bank.guided.action.purchase': 'Compra conocida',
  'bank.guided.action.sale': 'Registrar venta',
  'bank.guided.suggestionFromSuper': 'Sugerencia de SuperPlumma',
  'bank.guided.receivables': 'Clientes',
  'bank.guided.suggestedCostAccount': 'Cuenta de gasto sugerida',
  'bank.guided.reason.sameAmount': 'Mismo importe y misma referencia de pago',
  'bank.guided.reason.textBased': 'Basado en el texto, el importe y asientos anteriores',
  'bank.guided.suggestsAction': 'Plumme sugiere: {{action}}',
  'bank.guided.vatLine': '{{account}} · IVA {{vat}} · Importe {{amount}}',
  'bank.guided.voucherSuffix': ' · justificante: {{name}}',
  'bank.guided.out': 'SALIDA',
  'bank.guided.in': 'ENTRADA',
  'bank.guided.moneyOut': 'SALIDA DE DINERO',
  'bank.guided.moneyIn': 'ENTRADA DE DINERO',
  'bank.guided.unprocessedLine': '{{direction}} · Sin procesar',
  'bank.guided.bankPeriod': 'Periodo bancario',
  'bank.guided.handledLeft': '{{handled}}/{{total}} procesadas · {{left}} pendientes',
  'bank.guided.reopenNote': 'Si reabres la conciliación, el periodo se desbloquea para revisión. Las líneas contabilizadas deben corregirse o anularse con registro de auditoría antes de poder procesarse de nuevo.',
  'bank.guided.toast.enterClosing': 'Introduce el saldo final del extracto bancario.',
  'bank.guided.err.checkIndividually': 'Una o más sugerencias deben revisarse individualmente.',
  'bank.guided.toast.suggestionsDone': '{{count}} sugerencias contabilizadas y hechas',
  'bank.guided.err.approveSuggestions': 'No se pudieron aprobar las sugerencias.',
  'bank.guided.toast.roundingPosted': 'La diferencia de redondeo de {{amount}} se ha contabilizado',
  'bank.guided.err.roundingFailed': 'No se pudo contabilizar la diferencia de redondeo.',
  'bank.guided.toast.markedNoVoucher': 'La compra se ha marcado como sin justificante',
  'bank.guided.err.saveChoice': 'No se pudo guardar la elección.',
  'bank.guided.err.voucherNotFound': 'No se encontró el justificante en la bandeja de entrada.',
  'bank.guided.err.linkFailed': 'No se pudo vincular el justificante.',
  'bank.guided.toast.noSafeHits': 'No se encontraron coincidencias seguras de justificantes que vincular.',
  'bank.guided.h.check': '¿Coinciden el periodo y el saldo?',
  'bank.guided.h.rest': '¿Para qué son los pagos restantes?',
  'bank.guided.p.check': 'Comprueba que es el extracto bancario correcto e introduce el saldo que aparece al final del periodo.',
  'bank.guided.p.rest': 'Elige para qué es cada pago. No necesitas conocer los números de cuenta: Plumme te ayuda con el asiento.',
  'bank.guided.openingHint': 'Normalmente se toma de la última conciliación completada.',
  'bank.guided.closingHint': 'Busca el importe en el extracto del banco.',
  'bank.guided.closingMatches': 'El saldo final del banco es igual al que ha calculado Plumme.',
  'bank.guided.posting': 'Contabilizando…',
  'bank.guided.postRounding': 'Contabilizar la diferencia de redondeo',
  'bank.guided.smallRounding': 'Pequeña desviación de redondeo de {{amount}}',
  'bank.guided.balanceDeviates': 'El saldo se desvía en {{amount}}.',
  'bank.guided.balanceDeviatesHelp': 'Procesa los pagos en los pasos siguientes y vuelve si la desviación persiste.',
  'bank.guided.canReturn': 'Siempre puedes volver a este paso más tarde.',
  'bank.guided.correctToContinue': 'Corrige los saldos con el icono del lápiz para continuar.',
  'bank.guided.checkedContinue': 'El extracto está revisado: continuar',
  'bank.guided.superIntro': 'Algunas líneas se concilian con asientos que ya están contabilizados y, para otras, SuperPlumma ha sugerido un asiento. Revísalas y pulsa aprobar: no se contabiliza nada hasta que apruebes.',
  'bank.guided.count.matched': 'conciliados con asientos ya contabilizados',
  'bank.guided.count.invoice': 'pagos de facturas',
  'bank.guided.count.purchase': 'compras conocidas',
  'bank.guided.count.fee': 'comisiones bancarias',
  'bank.guided.count.receipt': 'justificantes encontrados automáticamente',
  'bank.guided.fixReading': 'Corregir la lectura del PDF/CSV',
  'bank.guided.suggestionsPending': '{{count}} sugerencias aún no están aprobadas. Puedes aprobarlas ahora o volver más tarde.',
  'bank.guided.allSuggestionsDone': 'Todas las sugerencias se han procesado.'
});
